(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lc-scripts"] && !Shopify.designMode) return;
  try {
    const links = document.querySelectorAll('.navlink');
for (let i = 0; i < links.length; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}
const flinks = document.querySelectorAll('.footer__quicklinks a');
for (let i = 0; i < flinks.length; i++) {
  if (flinks[i].hostname !== window.location.hostname) {
    flinks[i].target = '_blank';
    flinks[i].rel = 'noreferrer noopener';
  }
}

const btns = document.querySelectorAll('a.btn');
for (let i = 0; i < links.length; i++) {
  if (btns[i].hostname !== window.location.hostname) {
    btns[i].target = '_blank';
    btns[i].rel = 'noreferrer noopener';
  }
}
  } catch(e) { console.error(e); }
})();

})();
